import { useGetUserHasShares } from '@fintronners/react-api/src/hooks/useGetUserHasShares';

export type UseUserOwnsSecurityParams = {
  securityId: string | null | undefined;
  skip?: boolean;
};

/**
 * Hook to check if a user owns a specific security in their portfolio
 * (i.e. has an active position with balance > 0).
 */
const useUserOwnsSecurity = ({ securityId, skip }: UseUserOwnsSecurityParams) => {
  const { userAccountPortfolioAssets, userShareDataLoading: loading } = useGetUserHasShares({
    skip: !securityId || skip,
    securityId: securityId!,
  });

  // If the user does not own the security, the edges array will be empty.
  const hasAlreadyFetched = userAccountPortfolioAssets && !loading;

  const firstNode = userAccountPortfolioAssets?.edges?.[0]?.node;
  const security = firstNode?.asset ?? null;
  const activeBalance = firstNode?.balances?.activeBalance ?? null;

  const ownsSecurity = hasAlreadyFetched ? activeBalance !== null && activeBalance > 0 : null;

  return { ownsSecurity, security, loading };
};

export default useUserOwnsSecurity;
